import {ClearAll as CleanIcon, Refresh as RefreshIcon} from '@mui/icons-material';
import {Box, Button, Typography} from '@mui/material';

export interface AdminJobsHeaderProps {
  jobsCount: number;
  loading: boolean;
  cleanupLoading: boolean;
  onRefresh: () => void;
  onCleanupClick: () => void;
}

export default function AdminJobsHeader({
  jobsCount,
  loading,
  cleanupLoading,
  onRefresh,
  onCleanupClick,
}: AdminJobsHeaderProps) {
  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2}}>
      <Typography variant="h6">Recent Jobs ({jobsCount})</Typography>
      <Box sx={{display: 'flex', gap: 1}}>
        <Button variant="outlined" startIcon={<RefreshIcon />} onClick={onRefresh} disabled={loading}>
          {loading ? 'Refreshing...' : 'Refresh'}
        </Button>
        <Button
          variant="outlined"
          startIcon={<CleanIcon />}
          onClick={onCleanupClick}
          disabled={cleanupLoading}
          color="warning"
        >
          {cleanupLoading ? 'Cleaning...' : 'Cleanup Old Jobs'}
        </Button>
      </Box>
    </Box>
  );
}
